import React, { Suspense, lazy } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ProtectedRoute from "./Layout/ProtectedRoute.jsx";
import TimeoutRedirect from "./Layout/TimeoutRedirect.jsx";
import BannerApply from "./Pages/BannerApply.jsx";
import BannerManage from "./Pages/BannerManage";
import ChallengeApply from "./Pages/ChallengeApply.jsx";
import ChallengeManage from "./Pages/ChallengeManage.jsx";
import DepartmentBattleApply from "./Pages/DepartmentBattleApply.jsx";
import DepartmentBattleManage from "./Pages/DepartmentBattleManage.jsx";
import Donation from "./Pages/Donation";
import EmailAuth from "./Pages/EmailAuth";
import EmailAuthSent from "./Pages/EmailAuthSent";
import EventApply from "./Pages/EventApply";
import EventManage from "./Pages/EventManage";
import ExpiredUpdatePW from "./Pages/ExpiredUpdatePW";
import Gifticon from "./Pages/Gifticon.jsx";
import InitUser from "./Pages/InitUser";
import Login from "./Pages/Login";
import MainPage from "./Pages/MainPage";
import Members from "./Pages/Members";
import NoticeApply from "./Pages/NoticeApply";
import NoticeManage from "./Pages/NoticeManage";
import Order from "./Pages/Order.jsx";
import OrderComplete from "./Pages/OrderComplete.jsx";
import OurContestDetail from "./Pages/OurContestDetail";
import OurContestManage from "./Pages/OurContestManage";
import PushApply from "./Pages/PushApply";
import PushManage from "./Pages/PushManage";
import QnAApply from "./Pages/QnAApply";
import QnAManage from "./Pages/QnAManage";
import ResetPW from "./Pages/ResetPW";
import SessionExpired from "./Pages/SessionExpired";
import SubscribeManage from "./Pages/SubscribeManage";
// import ApplicationFormMobile from "./RankingMarathon_web/ApplicationFormMobile.jsx";
// import RankingMarathonWeb from "./RankingMarathon_web/RankingMarathonWeb.jsx";

const NewRankingMarathonWeb = lazy(() =>
  import("./NewRankingMarathonWeb/index.jsx")
);
const Service = lazy(() => import("./NewRankingMarathonWeb/pages/Service.jsx"));
const Apply = lazy(() => import("./NewRankingMarathonWeb/pages/Apply.jsx"));

const ProtectedLayout = () => {
  return (
    <ProtectedRoute>
      <TimeoutRedirect>
        <Routes>
          <Route path="/init_user" element={<InitUser />} />
          <Route path="/home" element={<MainPage />} />
          <Route path="/member" element={<Members />} />
          <Route path="/notice" element={<NoticeManage />} />
          <Route path="/notice/apply" element={<NoticeApply />} />
          <Route path="/notice/edit/:id" element={<NoticeApply />} />
          <Route path="/event" element={<EventManage />} />
          <Route path="/event/apply" element={<EventApply />} />
          <Route path="/event/edit/:id" element={<EventApply />} />
          <Route path="/event/detail/:id" element={<EventApply />} />
          <Route path="/meetWe" element={<OurContestManage />} />
          <Route path="/meetWe/detail/:id" element={<OurContestDetail />} />
          <Route path="/meetWe/edit/:id" element={<OurContestDetail />} />
          <Route path="/departmentBattle" element={<DepartmentBattleManage />} />
          <Route
            path="/departmentBattle/apply"
            element={<DepartmentBattleApply />}
          />
          <Route
            path="/departmentBattle/edit/:id"
            element={<DepartmentBattleApply />}
          />
          <Route
            path="/departmentBattle/detail/:id"
            element={<DepartmentBattleApply />}
          />
          <Route path="/banner" element={<BannerManage />} />
          <Route path="/banner/apply" element={<BannerApply />} />
          <Route path="/banner/edit/:id" element={<BannerApply />} />
          <Route path="/qna" element={<QnAManage />} />
          <Route path="/qna/apply/:id" element={<QnAApply />} />
          <Route path="/push" element={<PushManage />} />
          <Route path="/push/apply" element={<PushApply />} />
          <Route path="/push/edit/:id" element={<PushApply />} />
          <Route path="/gifticon" element={<Gifticon />} />
          <Route path="/gifticon/order" element={<Order />} />
          <Route path="/gifticon/order/complete" element={<OrderComplete />} />
          <Route path="/challenge" element={<ChallengeManage />} />
          <Route path="/challenge/apply" element={<ChallengeApply />} />
          <Route path="/challenge/edit/:id" element={<ChallengeApply />} />
          <Route path="/company" element={<SubscribeManage />} />
          <Route path="/donation" element={<Donation />} />
          <Route path="/expiredpw" element={<ExpiredUpdatePW />} />
        </Routes>
      </TimeoutRedirect>
    </ProtectedRoute>
  );
};

function App() {
  return (
    <>
      <ToastContainer />
      <Router>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/RMweb" element={<NewRankingMarathonWeb />} />
            <Route path="/RMweb/service" element={<Service />} />
            <Route path="/RMweb/application" element={<Apply />} />
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Navigate to="/" />} />
            <Route path="/*" element={<ProtectedLayout />} />
            <Route path="/emailauth" element={<EmailAuth />} />
            <Route path="/emailauth/sent" element={<EmailAuthSent />} />
            <Route path="/updatepw" element={<ResetPW />} />
            <Route path="/sessionexpired" element={<SessionExpired />} />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

const RouteFallback = () => null;

export default App;
